// extracted by mini-css-extract-plugin
export default {"image":"FY-z","loaded":"GY-z"};